/**
 * 环境变量
 * 注意：此文件不要通过 import 引入其他文件。因为它是要最早初始化
 */

let environment = {};
environment = {
  VUE_APP_TITLE: process.env.VUE_APP_TITLE,
  VUE_APP_MODE: process.env.VUE_APP_MODE,
  VUE_APP_STORAGE: process.env.VUE_APP_STORAGE,
  VUE_APP_API: process.env.VUE_APP_API,
  VUE_APP_HOST: process.env.VUE_APP_HOST,
  VUE_APP_SIT_CONTEXT: process.env.VUE_APP_SIT_CONTEXT
};

export default environment;
